module.exports = __webpack_public_path__ + "static/media/Pin_KeyReplace.58df8030.svg";